import { useMutation, useQueryClient } from '@tanstack/react-query';
import { saveCaseCustomFields } from '../../api/integrations';
import type { CaseCustomFieldsResponse, CaseCustomFieldWire } from '../../api/integrations';
import { caseCustomFieldsQueryKey } from './use-case-custom-fields';

export function useSaveCaseCustomFields(orgId: string, productId: string) {
  const qc = useQueryClient();
  return useMutation<
    CaseCustomFieldsResponse,
    Error,
    Array<Omit<CaseCustomFieldWire, 'display_order'>>
  >({
    mutationFn: (fields) => saveCaseCustomFields(orgId, productId, fields),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: caseCustomFieldsQueryKey(orgId, productId) });
      void qc.invalidateQueries({ queryKey: ['integration', orgId, productId] });
    },
  });
}
